import { render, staticRenderFns } from "./HeaderBySectionDropdown.vue?vue&type=template&id=3c136746&scoped=true&"
import script from "./HeaderBySectionDropdown.vue?vue&type=script&lang=js&"
export * from "./HeaderBySectionDropdown.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBySectionDropdown.vue?vue&type=style&index=0&id=3c136746&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c136746",
  null
  
)

export default component.exports